import './styles.css';
import { Game } from './game/Game';

const canvas = document.querySelector<HTMLCanvasElement>('#game-canvas');
if (!canvas) throw new Error('Missing #game-canvas element.');

function showGraphicsIssue(message: string, recovering = false): void {
  document.querySelector('#graphics-status')?.remove();
  const panel = document.createElement('section');
  panel.id = 'graphics-status';
  panel.setAttribute('role', 'alert');
  const title = document.createElement('h1');
  title.textContent = recovering ? 'Se interrumpieron los gráficos' : 'No se pudo iniciar el juego';
  const explanation = document.createElement('p');
  explanation.textContent = recovering
    ? 'El navegador perdió la conexión con la tarjeta gráfica. El juego intentará recuperar la imagen automáticamente.'
    : 'El navegador no pudo iniciar el juego. Si Chrome bloqueó los gráficos, cierra todas las ventanas de Chrome y vuelve a abrir el juego. Si persiste, revisa la aceleración gráfica en la configuración del navegador.';
  const detail = document.createElement('p');
  detail.textContent = `Detalle: ${message}`;
  const retry = document.createElement('button');
  retry.type = 'button';
  retry.textContent = 'Reintentar carga';
  retry.addEventListener('click', () => window.location.reload());
  panel.append(title, explanation, detail, retry);
  document.body.append(panel);
}

const onContextLost = (event: Event) => {
  event.preventDefault();
  showGraphicsIssue((event as WebGLContextEvent).statusMessage || 'Contexto WebGL perdido.', true);
};
const onContextRestored = () => document.querySelector('#graphics-status')?.remove();
canvas.addEventListener('webglcontextlost', onContextLost);
canvas.addEventListener('webglcontextrestored', onContextRestored);

let game: Game | undefined;
try {
  game = new Game(canvas);
  void game.start().catch(error => showGraphicsIssue(error instanceof Error ? error.message : String(error)));
} catch (error) {
  showGraphicsIssue(error instanceof Error ? error.message : String(error));
}

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    canvas.removeEventListener('webglcontextlost', onContextLost);
    canvas.removeEventListener('webglcontextrestored', onContextRestored);
    document.querySelector('#graphics-status')?.remove();
    game?.dispose();
  });
}
